import * as React from "react";

export enum RouteNames {
  /** @deprecated */
  FORGOT_PASSWORD = "FORGOT_PASSWORD",
  /** @deprecated */
  REGISTER = "REGISTER",

  PLAY = "PLAY",
  VIDEO_FULL_SCREEN = "VIDEO_FULL_SCREEN",
  GAME = "GAME",
  PAGE = "PAGE",
  // @Deprecated use PAGE
  LIST = "LIST",

  HOME = "HOME",
  /** @deprecated */
  MY_ACCOUNT = "MY_ACCOUNT",
  /** @deprecated */
  MY_EMAIL = "MY_EMAIL",
  /** @deprecated */
  MY_PASSWORD = "MY_PASSWORD",

  SETTINGS = "SETTINGS",
  /** @deprecated */
  PAYMENT = "PAYMENT",
  ACCOUNT = "ACCOUNT",
  /** @deprecated */
  ERROR = "ERROR",
  /** @deprecated */
  DISCOUNT = "DISCOUNT",
  /** @deprecated */
  OFFERS = "OFFERS",
  SUBSCRIPTION = "SUBSCRIPTION",
  PLAN_SELECTION = "PLAN_SELECTION",
  /** @deprecated */
  PAYMENT_SELECTION = "PAYMENT_SELECTION",
  /** @deprecated */
  PAYMENT_SELECTION_CARD = "PAYMENT_SELECTION_CARD",
  /** @deprecated */
  PAYMENT_SELECTION_COUPON = "PAYMENT_SELECTION_COUPON",
  /** @deprecated */
  THANKS = "THANKS",
  SELECT_PROFILE = "SELECT_PROFILE",
  PROFILES = "PROFILES",
  ADD_PROFILE = "ADD_PROFILE",
  PROFILE_UNLOCK = "PROFILE_UNLOCK",
  EDIT_PROFILE = "EDIT_PROFILE",
  ADVANCED_SETTINGS = "ADVANCED_SETTINGS",
  SUPPORT = "SUPPORT",
  REMOTE_NOTIFICATIONS = "REMOTE_NOTIFICATIONS",
  /** @deprecated */
  LOGIN = "LOGIN",
  SEARCH = "SEARCH",
  SEARCH_RESULTS = "SEARCH_RESULTS",
  STREAM_RECOVERY = "STREAM_RECOVERY",
  LAST_PLAYED = "LAST_PLAYED",
  FAVORITES = "FAVORITES",
  /** @deprecated */
  TERMS = "TERMS",
}

export type Route =
  | {
      name: RouteNames.SUBSCRIPTION;
      screenID?: string;
      fromResetPassword?: boolean;
      login?: string;
      preId?: string;
      clearHistory?: boolean;
      referrer?: string;
    }
  | {
      name: RouteNames.LOGIN;
      screenID?: string;
      login?: string;
      fromResetPassword?: boolean;
      preId?: string;
      referrer?: string;
    }
  | {
      name: RouteNames.PLAN_SELECTION;
      screenID?: string;
      clearHistory?: boolean;
      preId?: string;
      referrer?: string;
    }
  | {
      name: RouteNames.PAYMENT_SELECTION;
      screenID?: string;
      preId?: string;
      referrer?: string;
      clearHistory?: boolean;
    }
  | {
      name: RouteNames.PAYMENT_SELECTION_CARD;
      screenID?: string;
      preId?: string;
      referrer?: string;
      returnUrl?: string;
    }
  | {
      name: RouteNames.PAYMENT_SELECTION_COUPON;
      screenID?: string;
      preId?: string;
      referrer?: string;
      returnUrl?: string;
    }
  | {
      name: RouteNames.THANKS;
      screenID?: string;
      preId?: string;
      referrer?: string;
      returnUrl?: string;
    }
  | {
      name: RouteNames.FORGOT_PASSWORD;
      screenID?: string;
      login?: string;
      preId?: string;
      referrer?: string;
    }
  | {
      name: RouteNames.REGISTER;
      screenID?: string;
      preId?: string;
    }
  | {
      name: RouteNames.TERMS;
      screenID?: string;
      preId?: string;
    }
  | {
      name: RouteNames.OFFERS;
    }
  | {
      name: RouteNames.SEARCH;
    }
  | {
      name: RouteNames.SEARCH_RESULTS;
    }
  | {
      name: RouteNames.SELECT_PROFILE;
      returnUrl?: string;
      clearHistory?: boolean;
      fromRegister?: boolean;
    }
  | {
      name: RouteNames.PROFILES;
      returnUrl?: string;
    }
  | {
      name: RouteNames.HOME;
      clearHistory?: boolean;
    }
  | {
      name: RouteNames.STREAM_RECOVERY;
      clearHistory?: boolean;
    }
  | {
      name: RouteNames.PLAY;
      gameId: string;
      streamId?: string;
      origin: "tile" | "hero" | "detail" | "trailer" | "recover";
      mode?: "recover" | "default" | "join" | "remote";
      clearHistory?: boolean;
    }
  | {
      name: RouteNames.VIDEO_FULL_SCREEN;
      gameId: string;
    }
  | {
      name: RouteNames.GAME;
      gameId: string;
    }
  | {
      name: RouteNames.PAGE;
      pageId: string;
    }
  | {
      name: RouteNames.LIST;
      pageId: string;
      listUuid: string;
    }
  | {
      name: RouteNames.FAVORITES;
      pageId: string;
      listUuid: string;
    }
  | {
      name: RouteNames.LAST_PLAYED;
      pageId: string;
      listUuid: string;
    }
  | {
      name: RouteNames.MY_ACCOUNT;
    }
  | {
      name: RouteNames.ACCOUNT;
    }
  | {
      name: RouteNames.MY_EMAIL;
    }
  | {
      name: RouteNames.SUPPORT;
    }
  | {
      name: RouteNames.MY_PASSWORD;
    }
  | {
      name: RouteNames.SETTINGS;
    }
  | {
      name: RouteNames.ADVANCED_SETTINGS;
    }
  | {
      name: RouteNames.PAYMENT;
    }
  | { name: RouteNames.DISCOUNT }
  | { name: RouteNames.ADD_PROFILE }
  | { name: RouteNames.PROFILE_UNLOCK; id: string; returnUrl?: string }
  | { name: RouteNames.EDIT_PROFILE; id: string }
  | {
      name: RouteNames.ERROR;
      error: string;
    }
  | { name: RouteNames.REMOTE_NOTIFICATIONS };

export interface WithRouterProps<T> {
  navigate: (route: Route | string) => void;
  back: () => void;
  routeParams?: T;
  isScreenForeground: boolean;
}

export const withRouter = <TOriginalProps extends {}, TParams extends {}>(
  Component: React.ComponentType<TOriginalProps>,
) => {
  type ResultProps = WithRouterProps<TParams> & TOriginalProps;
  const result = class WithRouter extends React.PureComponent<ResultProps> {
    public static displayName = `WithRouter(${Component.displayName || Component.name})`;

    constructor(props: ResultProps) {
      super(props);
    }

    public render() {
      return <Component {...this.props} />;
    }
  };

  return result;
};
